var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptycartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9942 62.9656C37.9482 61.2185 39.7709 60.1333 41.7506 60.1333H78.9815C83.0527 60.1333 86.6354 57.892 88.481 54.5027L106.833 20.9396C107.429 19.8493 107.615 18.6427 107.442 17.5005C108.405 16.5138 109 15.1602 109 13.6667C109 10.6475 106.57 8.2 103.572 8.2H22.1472C21.9683 8.2 21.7913 8.20875 21.6168 8.22575L20.6908 6.25578C18.8954 2.43578 15.0746 0 10.878 0H5.4283C2.43036 0 0 2.44754 0 5.46667C0 8.4858 2.43036 10.9333 5.4283 10.9333H6.65042C9.2192 10.9333 11.5583 12.4232 12.6592 14.7606L28.011 47.3561C29.5097 50.5382 29.3945 54.2528 27.7014 57.3344L23.0703 65.764C19.1076 73.0893 24.3188 82 32.5698 82H92.2808C95.2789 82 97.7091 79.5526 97.7091 76.5333C97.7091 73.5141 95.2789 71.0667 92.2808 71.0667H41.7505C37.6217 71.0667 35.0044 66.6086 36.9942 62.9656Z",
    fill: "#C5CED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9724 87C25.9073 87 21 91.95 21 98C21 104.05 25.9073 109 31.9724 109C38.0376 109 43 104.05 43 98C43 91.95 38.0376 87 31.9724 87Z",
    fill: "#C5CED6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9724 87C80.9073 87 76 91.95 76 98C76 104.05 80.9073 109 86.9724 109C93.0376 109 98 104.05 98 98C98 91.95 93.0376 87 86.9724 87Z",
    fill: "#C5CED6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34C44 31.7909 45.7909 30 48 30H72C74.2091 30 76 31.7909 76 34V37C76 39.2091 74.2091 41 72 41H48C45.7909 41 44 39.2091 44 37V34Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptycartIcon);
export default __webpack_public_path__ + "static/media/emptycartIcon.3207534058c5540853cf4e3cfa655165.svg";
export { ForwardRef as ReactComponent };